import { useRouteError } from 'react-router-dom';

export const RouteErrorBoundary = () => {
  const error = useRouteError();
  throw error;
};
